var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "settings-users-tab" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-center mt-3 mb-4",
        },
        [
          _c("v-text-field", {
            staticClass: "search-field",
            attrs: {
              placeholder: _vm.$t("pages.settings.users.searchPlaceholder"),
              outlined: "",
              dense: "",
              "background-color": "white",
              clearable: "",
              "hide-details": "",
              autocomplete: "off",
              name: "usersTabSearch",
            },
            scopedSlots: _vm._u([
              {
                key: "prepend-inner",
                fn: function () {
                  return [_c("v-icon", [_vm._v(_vm._s(_vm.icons.mdiMagnify))])]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.params.query,
              callback: function ($$v) {
                _vm.$set(_vm.params, "query", $$v)
              },
              expression: "params.query",
            },
          }),
          _c(
            "v-btn",
            { attrs: { color: "primary" }, on: { click: _vm.onClickAdd } },
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v(" " + _vm._s(_vm.icons.mdiPlus) + " "),
              ]),
              _vm._v(
                " " + _vm._s(_vm.$t("pages.settings.users.addUser")) + " "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.tableData,
          loading: _vm.loading,
          "no-data-text": _vm.$t("pages.settings.users.empty"),
          "items-per-page": -1,
          "hide-default-footer": "",
          "disable-sort": "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.name`,
              fn: function ({ item }) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(item.name && item.name.trim() ? item.name : "-") +
                      " "
                  ),
                ]
              },
            },
            {
              key: `item.created`,
              fn: function ({ item }) {
                return [
                  _vm._v(" " + _vm._s(_vm.formatDate(item.created)) + " "),
                ]
              },
            },
            {
              key: `item.validDate`,
              fn: function ({ item }) {
                return [
                  _vm._v(" " + _vm._s(_vm.formatDate(item.validDate)) + " "),
                ]
              },
            },
            {
              key: `item.lastSeenAt`,
              fn: function ({ item }) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.formatDate(item.lastSeenAt, true)) + " "
                  ),
                ]
              },
            },
            {
              key: `item.selectedIdea`,
              fn: function ({ item }) {
                return [
                  item.selectedIdea
                    ? _c(
                        "span",
                        {
                          staticClass: "d-inline-block text-truncate",
                          staticStyle: { "max-width": "150px" },
                          attrs: { title: item.selectedIdea },
                        },
                        [_vm._v(" " + _vm._s(item.selectedIdea) + " ")]
                      )
                    : _c("span", [_vm._v("-")]),
                ]
              },
            },
            {
              key: `item.progress`,
              fn: function ({ item }) {
                return [
                  item.selectedIdea
                    ? _c("el-progress", {
                        attrs: {
                          percentage: item.selectedIdeaProgress || 0,
                          "stroke-width": 8,
                          color: _vm.progressBarCustomColorMethod,
                        },
                      })
                    : _c("span", [_vm._v("-")]),
                ]
              },
            },
            {
              key: `item.ideas`,
              fn: function ({ item }) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(item.ideasCreated) +
                      " / " +
                      _vm._s(item.maxIdeas) +
                      " "
                  ),
                ]
              },
            },
            {
              key: `item.actions`,
              fn: function ({ item }) {
                return [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickEdit(item)
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.icons.mdiPencil) + " "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("edit")))])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "error",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickDelete(item)
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.icons.mdiDeleteOutline) +
                                          " "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("delete")))])]
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm.pagination && _vm.pagination.total > 0
        ? _c(
            "div",
            { staticClass: "pagination-wrapper p-3" },
            [
              _c("v-pagination", {
                attrs: {
                  length: _vm.totalPages,
                  disabled: _vm.loading,
                  "total-visible": 11,
                },
                model: {
                  value: _vm.params.page,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "page", $$v)
                  },
                  expression: "params.page",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("dialog-add-user", {
        on: {
          close: function ($event) {
            _vm.dialogAddUserVisible = false
          },
          finished: _vm.onUserSaved,
        },
        model: {
          value: _vm.dialogAddUserVisible,
          callback: function ($$v) {
            _vm.dialogAddUserVisible = $$v
          },
          expression: "dialogAddUserVisible",
        },
      }),
      _c("dialog-edit-user", {
        attrs: { user: _vm.selectedUser },
        on: {
          close: function ($event) {
            _vm.dialogEditUserVisible = false
          },
          finished: _vm.onUserSaved,
        },
        model: {
          value: _vm.dialogEditUserVisible,
          callback: function ($$v) {
            _vm.dialogEditUserVisible = $$v
          },
          expression: "dialogEditUserVisible",
        },
      }),
      _c("dialog-delete-user", {
        attrs: { user: _vm.selectedUser },
        on: {
          close: function ($event) {
            _vm.dialogDeleteUserVisible = false
          },
          finished: _vm.onUserSaved,
        },
        model: {
          value: _vm.dialogDeleteUserVisible,
          callback: function ($$v) {
            _vm.dialogDeleteUserVisible = $$v
          },
          expression: "dialogDeleteUserVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }